<template>
  <UiDisclosure open>
    <UiDisclosureButton
      class="title text-sm uppercase tracking-[0.12em] text-slate"
    >
      {{ item.name }}
    </UiDisclosureButton>

    <UiDisclosurePanel>
      <div class="mt-6 space-y-4 leading-[1.225rem]">
        <UiCheckbox
          v-for="filterOption in item.buckets"
          :key="filterOption.id"
          v-model="valueLocal"
          :disabled="disabled"
          :checkbox-value="filterOption.id"
          class="text-sm text-slate"
        >
          {{ filterOption.name }}
        </UiCheckbox>
      </div>
    </UiDisclosurePanel>
  </UiDisclosure>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  modelValue?: any[];
  item?: any;
  disabled?: boolean;
}
interface Emits {
  (e: 'update:modelValue', data: Props['modelValue']): void;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
  item: () => ({}),
  disabled: false,
});

const emit = defineEmits<Emits>();
const valueLocal = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>
